import React from 'react';
import { observer } from 'mobx-react';

import { formatCurrency, formatMoney, minutesToHours } from 'js/services/Format';
import Container from '../Container';
import Col from '../Col';
import RadioInput from './RadioInput';
import Estimate from './Estimate';
import Summary from './Summary';
import Row from './Row';
import GokadaLabel from 'js/components/core/form/ShippingSelector/display/Options/GokadaLabel';

export default observer(({ state, ...rest }) => {
  return (
    <Container {...rest}>
      {state.shippingOptions.map((option, index) => {
        const changeCallback = () => state.setValue(option);
        return (
          <>
            <Row key={index} onClick={changeCallback}>
              <RadioInput
                name="shippingService"
                isChosen={state.shippingService === option.service}
                value={option.service}
                onChange={changeCallback}
              />
              <Col>
                <Estimate>
                  {'Gokada' === option.brand ? <GokadaLabel>
                      {option.label}
                      <small>{minutesToHours(option.estDeliveryTime)} delivery*</small>
                    </GokadaLabel>
                    : 'Fez' === option.brand ? <GokadaLabel>
                        {option.label}
                        <small>{minutesToHours(option.estDeliveryTime)} delivery*</small>
                      </GokadaLabel>
                      :
                    !option.isSameDay ? '2-4 days delivery*' : option.delivery === 'short' ? '2-hours delivery*' : '6-hours delivery*'
                  }
                </Estimate>
                <Summary>
                  {'Gokada' === option.brand || 'Fez' === option.brand ? `via ${option.brand}` : `via ${option.brand} - ${option.isSameDay ? 'Same-day' : 'Standard'}`}
                </Summary>
              </Col>

              <Col justify="center" padding="1rem 1rem 1rem 0">
                {'Gokada' === option.brand || 'Fez' === option.brand
                  ?
                  formatCurrency(option.price, 'NGN') + (option.priceMax ? ' -> ' + formatCurrency(option.priceMax, 'NGN') : '')
                  :
                  formatCurrency(option.price, 'USD')}
              </Col>
            </Row>
          </>
        );
      })}
    </Container>
  )
});
